import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LambdaService } from 'src/app/lambda.service';
import { ThemingService } from 'src/app/theming.service';
import { Region } from 'src/app/region/models/region.interface';
import { RegionBackendService } from 'src/app/region/services/regions.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth.service';
declare var $: any;

@Component({
  selector: 'app-beneficiaries',
  templateUrl: './beneficiaries.component.html',
  styleUrls: ['./beneficiaries.component.scss']
})
export class BeneficiariesComponent implements OnInit {
  @Input() beneficiaries: any[] = [];
  @Input() clientNationalId: string = '';
  // Control de vistas: 'list' | 'create' | 'edit'
  currentView: 'list' | 'create' | 'edit' = 'list';

  // Datos
  selectedBeneficiary: any = null;
  selectedIndex: number | null = null;

  // Formulario
  beneficiaryForm!: FormGroup;
  loadingBeneficiaries = false;
  nationalIdInvalid = false;
  currentRelationship = '';

  // Ubicación
  public provincias: Region[] = [];
  public cantones: Region[] = [];
  public distritos: Region[] = [];
  private _subscriptions:Subscription = new Subscription();
  public selectedProvinciaId: string = '';
  public selectedCantonId: string = '';
  public selectedDistritoId: string = '';
  provinciaName = "";
  cantonName = "";
  distritoName = "";
  beneficiaryRegionId: any;
  beneficiaryAddress: any;
  
  currentUser: any;

  // Relaciones
  validRelationships: string[] = ['Perro', 'Gato'];
  validateResponsibleRelationships: string[] = ['Perro', 'Gato', 'Hijo', 'Hija'];

  // Campos que solo son requeridos para personas
  personRequiredFields = ['beneficiaryNationalId', 'beneficiaryLastName', 'beneficiaryDocumentType'];

  // Campos que solo son requeridos para animales
  animalRequiredFields = ['beneficiaryBreed', 'beneficiaryWeight'];

  constructor(
    private fb: FormBuilder,
    private lambdaService: LambdaService,
    public themingService: ThemingService,
    private readonly _region: RegionBackendService,
    private authService: AuthService,
  ) {}
  async ngOnInit(): Promise<void> {
    this.initForm();
    this.loadBeneficiaries();
    this.currentUser = await this.authService.currentAuthUser();
    console.log("this.currentUser", this.currentUser);
    this._subscriptions.add(
      this._region.getSubregions(this._region.crId)
      .subscribe(value => {
          this.provincias = value;
      })
    );
  }

  private initForm(): void {
    this.beneficiaryForm = this.fb.group({
      beneficiaryName: ['', Validators.required],
      beneficiaryNationalId: [''],
      beneficiaryBornDate: [''],
      beneficiaryGender: [''],
      beneficiaryPhone: [''],
      beneficiaryEmail: [''],
      beneficiaryLastName: [''],
      beneficiaryRelationship: ['', Validators.required],
      beneficiaryBreed: [''],
      beneficiaryColor: [''],
      beneficiaryWeight: [''],
      beneficiaryDocumentType: [''],
      selectedProvinciaId: [''],
      selectedCantonId: [''],
      selectedDistritoId: [''],
      beneficiaryAddress: ['']
    });
  }

  // ==================== NAVEGACIÓN ENTRE VISTAS ====================

  openCreateView(): void {
    this.selectedBeneficiary = null;
    this.selectedIndex = null;
    this.resetForm();
    this.currentView = 'create';
  }

  openEditView(index: number): void {
    this.selectedIndex = index;
    this.selectedBeneficiary = { ...this.beneficiaries[index] };
    console.log("this.selectedBeneficiary", this.selectedBeneficiary);
    this.patchFormValues(this.selectedBeneficiary);
    this.currentView = 'edit';
  }

  backToList(): void {
    this.currentView = 'list';
    this.selectedBeneficiary = null;
    this.selectedIndex = null;
    this.resetForm();
  }

  private resetForm(): void {
    this.beneficiaryForm.reset();
    this.currentRelationship = '';
    this.nationalIdInvalid = false;
    this.provinciaName = '';
    this.cantonName = '';
    this.distritoName = '';
  }

  private patchFormValues(data: any): void {
    this.beneficiaryForm.patchValue({
      beneficiaryName: data.beneficiaryName,
      beneficiaryNationalId: data.beneficiaryNationalId,
      beneficiaryBornDate: data.beneficiaryBornDate,
      beneficiaryGender: data.beneficiaryGender,
      beneficiaryPhone: data.beneficiaryPhone,
      beneficiaryEmail: data.beneficiaryEmail,
      nationalId: data.nationalId,
      beneficiaryLastName: data.beneficiaryLastName,
      beneficiaryRelationship: data.beneficiaryRelationship,
      beneficiaryBreed: data.beneficiaryBreed,
      beneficiaryColor: data.beneficiaryColor,
      beneficiaryWeight: data.beneficiaryWeight,
      beneficiaryDocumentType: data.beneficiaryDocumentType,
      selectedProvinciaId: data.selectedProvinciaId,
      selectedCantonId: data.selectedCantonId,
      selectedDistritoId: data.selectedDistritoId,
      beneficiaryAddress: data.beneficiaryAddress
    });
    this.currentRelationship = data.beneficiaryRelationship || '';
    this.provinciaName = data.provinciaName || '';
    this.cantonName = data.cantonName || '';
    this.distritoName = data.distritoName || '';
    this.updateValidatorsByRelationship();
  }

  // ==================== CARGA DE DATOS ====================

  private loadBeneficiaries(): void {
    // this.lambdaService.getBeneficiaries(this.themingService.shopTheming[0].shopId)
    //   .then(res => this.beneficiaries = res.data);
  }

  // ==================== GUARDAR (CREATE / UPDATE) ====================

  saveBeneficiary(): void {
    this.validateBeneficiaryNationalId();
    if (this.nationalIdInvalid) {
      console.error('The ID number is invalid.');
      return;
    }
    console.log("this.beneficiaryForm",this.beneficiaryForm);
    console.table(this.beneficiaryForm);
    console.log("this.beneficiaryForm.valid",this.beneficiaryForm.valid);
    if (this.beneficiaryForm.valid) {
      this.loadingBeneficiaries = true;
      const resourceData = this.beneficiaryForm.value;

      const isEdit = this.currentView === 'edit';
      const requestPromise = isEdit
        ? this.lambdaService.updateBeneficiary(
          this.themingService.shopTheming[0].shopId, 
          this.selectedBeneficiary.beneficiaryId, 
          resourceData.beneficiaryName,
          resourceData.beneficiaryNationalId,
          resourceData.beneficiaryBornDate,
          resourceData.beneficiaryGender,
          resourceData.beneficiaryPhone,
          resourceData.beneficiaryEmail,
          resourceData.beneficiaryLastName,
          resourceData.beneficiaryRelationship,
          resourceData.beneficiaryBreed,
          resourceData.beneficiaryColor,
          resourceData.beneficiaryWeight,
          resourceData.beneficiaryDocumentType,
          this.currentUser
        )
        : this.lambdaService.createBeneficiaries(
        this.themingService.shopTheming[0].shopId,
        resourceData.beneficiaryName,
        resourceData.beneficiaryNationalId,
        resourceData.beneficiaryBornDate,
        resourceData.beneficiaryGender,
        resourceData.beneficiaryPhone,
        resourceData.beneficiaryEmail,
        this.clientNationalId,
        resourceData.beneficiaryLastName,
        resourceData.beneficiaryRelationship,
        resourceData.beneficiaryBreed,
        resourceData.beneficiaryColor,
        resourceData.beneficiaryWeight,
        resourceData.beneficiaryDocumentType,
        resourceData.selectedDistritoId,
        resourceData.beneficiaryAddress,
        this.provinciaName,
        this.cantonName,
        this.distritoName,
        this.currentUser
      );

      requestPromise
        .then((response: any) => {
          const isCreated = response.data?.isCreated;
          const statusCode = response.status ?? response.data?.statusCode;
          if (statusCode == 200 && (isCreated == 1 || isEdit)) {
            if (isEdit) {
              $('#successUpdateBeneficiariesModal').modal('show');
            } else {
              $('#successCreateBeneficiariesModal').modal('show');
            }
            if (isEdit && this.selectedIndex !== null) {
              this.beneficiaries[this.selectedIndex] = {
                ...resourceData,
                id: this.selectedBeneficiary.id,
                provinciaName: this.provinciaName,
                cantonName: this.cantonName,
                distritoName: this.distritoName
              };
            } else {
              this.beneficiaries.push({
                ...resourceData,
                provinciaName: this.provinciaName,
                cantonName: this.cantonName,
                distritoName: this.distritoName
              });
            }
            this.backToList();
          } else if (statusCode == 409 && isCreated == 0) {
            $('#errorTwoBeneficiariesModal').modal('show');
          } else {
            $('#errorBeneficiariesModal').modal('show');
          }
        })
        .catch((error: Error) => {
          console.error('Error en la API:', error);
          $('#errorBeneficiariesModal').modal('show');
        })
        .finally(() => {
          this.loadingBeneficiaries = false;
        });
    }
  }

  updateValidatorsByRelationship(): void {
    const relationship = this.beneficiaryForm.get('beneficiaryRelationship')?.value;
    const isAnimal = this.validRelationships.includes(relationship);

    // Personas: nationalId y lastName son requeridos
    this.personRequiredFields.forEach(field => {
      const control = this.beneficiaryForm.get(field);
      if (control) {
        if (!isAnimal) {
          control.setValidators([Validators.required]);
        } else {
          control.clearValidators();
          control.setValue(''); // 👈 limpia el valor al cambiar a animal
        }
        control.updateValueAndValidity();
      }
    });

    // Animales: breed y weight son requeridos
    this.animalRequiredFields.forEach(field => {
      const control = this.beneficiaryForm.get(field);
      if (control) {
        if (isAnimal) {
          control.setValidators([Validators.required]);
        } else {
          control.clearValidators();
          control.setValue(''); // 👈 limpia el valor al cambiar a persona
        }
        control.updateValueAndValidity();
      }
    });
  }

  // ==================== ELIMINAR ====================

  removeBeneficiary(index: number): void {
    if (confirm('¿Estás seguro de eliminar este beneficiario?')) {
      const beneficiary = this.beneficiaries[index];
      // this.lambdaService.deleteBeneficiaries(beneficiary.id).then(...)
      this.beneficiaries.splice(index, 1);
    }
  }

  // ==================== HANDLERS DEL FORMULARIO ====================

  onChangeRelationship(event: Event): void {
    const target = event.target as HTMLSelectElement;
    this.currentRelationship = target.value;
    this.beneficiaryForm.get('beneficiaryRelationship')?.setValue(this.currentRelationship);
    this.updateValidatorsByRelationship();
  }

  validateBeneficiaryNationalId(): void {
    const value = this.beneficiaryForm.get('beneficiaryNationalId')?.value || '';
    const type = this.beneficiaryForm.get('beneficiaryDocumentType')?.value;

    if (type === 'ID') {
      this.nationalIdInvalid = !(value.length === 9 && /^\d+$/.test(value));
    } else if (type === 'Passport') {
      this.nationalIdInvalid = !/^[A-Z][0-9]{8,11}$/.test(value);
    } else if (type === 'DIMEX') {
      this.nationalIdInvalid = !/^[1-9][0-9]{11}$/.test(value);
    } else if (type === 'other') {
      this.nationalIdInvalid = value.length === 0; // Inválido si está vacío
    } else {
      this.nationalIdInvalid = false;
    }
  }

  onProvinciaChange(event: Event) {
    // const selectedId = (event.target as HTMLSelectElement).value;
    // const selectedId = this.beneficiaryForm.get('selectedProvinciaId')?.value;
    const selectElement = event.target as HTMLSelectElement;
    const selectedId = selectElement.value; // esto es el ID
    this.provinciaName = selectElement.options[selectElement.selectedIndex]?.text; // esto es el nombre
    console.log(this.provinciaName)
    this.selectedProvinciaId = selectedId;
    this.cantones = [];
    this.distritos = [];
    if (selectedId) {
      this._subscriptions.add(
        this._region.getSubregions(selectedId).subscribe((response) => {
          this.cantones = response;
        })
      );
    }
  }

  onCantonChange(event: Event) {
    // const selectedId = (event.target as HTMLSelectElement).value;
    // const selectedId = this.beneficiaryForm.get('selectedProvinciaId')?.value;
    const selectElement = event.target as HTMLSelectElement;
    const selectedId = selectElement.value; // esto es el ID
    this.cantonName = selectElement.options[selectElement.selectedIndex]?.text; // esto es el nombre
    console.log(this.cantonName)
    this.selectedCantonId = selectedId;
    this.distritos = [];
    if (selectedId) {
      this._subscriptions.add(
        this._region.getSubregions(selectedId).subscribe((response) => {
          this.distritos = response;
        })
      );
    }
  }

  onDistritoChange(event: Event) {
    // const selectedId = (event.target as HTMLSelectElement).value;
    // const selectedId = this.beneficiaryForm.get('selectedProvinciaId')?.value;
    const selectElement = event.target as HTMLSelectElement;
    const selectedId = selectElement.value; // esto es el ID
    this.distritoName = selectElement.options[selectElement.selectedIndex]?.text; // esto es el nombre
    console.log(this.distritoName)
    this.selectedDistritoId = selectedId;
    this.beneficiaryRegionId = selectedId;
  }

  // ==================== MODALES ====================

  private showSuccessModal(): void {
    // tu implementación
  }

  private showGenericErrorModal(): void {
    // tu implementación
  }

  closeBeneficiariesModal() {
    $('#successCreateBeneficiariesModal').modal('hide');
    $('#successUpdateBeneficiariesModal').modal('hide');
    $('#errorTwoBeneficiariesModal').modal('hide');
    $('#errorBeneficiariesModal').modal('hide');

  }
}